import React from "react";
import chex from "../../components/chex.jpeg";
import letter1 from "./ChexSystems Letter 1.pdf";
import letter2 from "./ChexSystems Letter 2.pdf";
import letter3 from "./ChexSystems Letter 3.pdf";
import letter4 from "./ChexSystems Letter 4.pdf";
import instructions from "./06-1_D_NEW ChexSystems Dispute Instructions.pdf";

function ChexSystem() {
  return (
    <div className="container">
      <div className="banner">
        <img src={chex} alt="" />
      </div>
      <div className="container_body">
        <div className="course">
          <h1>Chex Systems</h1>
          <p>
            Download all the resources listed in this module. As always, these
            resources can be found here as well:{" "}
            <a href="https://drive.google.com/drive/folders/1so2X1Vy61eBjbTqJqJd_Lz1BNehDQZLT?usp=drive_link">
              Chex Systems
            </a>
          </p>
          <p>
            How to get a bank account when in Chex Systems{" "}
            <a href="https://drive.google.com/file/d/1OYTAA_aOdHP5aTh_W_prm9VK5z_95_EK/view?usp=drive_link">
              https://drive.google.com/file/d/1OYTAA_aOdHP5aTh_W_prm9VK5z_95_EK/view?usp=drive_link
            </a>
          </p>
          <p>
            How to get out of Early Warning Systems{" "}
            <a href="https://drive.google.com/file/d/1h6p-srBPBY4MRipA95B3hcwzV6L1aMlK/view?usp=drive_link">
              https://drive.google.com/file/d/1h6p-srBPBY4MRipA95B3hcwzV6L1aMlK/view?usp=drive_link
            </a>
          </p>
        </div>
        <div className="downloads">
          <h3>Downloads</h3>
          <a href={letter4}> 06-5_D_NEW_ChexSystems_Letter_4.pdf</a>
          <a href={letter3}>06-4_D_NEW_ChexSystems_Letter_3.pdf</a>
          <a href={letter2}>06-3_D_NEW_ChexSystems_Letter_2.pdf</a>
          <a href={letter1}>06-2_D_NEW_ChexSystems_Letter_1.pdf</a>
          <a href={instructions}>NEW_ChexSystems_Dispute_Instructions.pdf</a>
        </div>
      </div>
    </div>
  );
}

export default ChexSystem;
